<template>
    <ModalFormCard class="modal-default lg:min-w-[600px]"
        :class='{ 
            "!w-[800px]": preview == null,
            "!w-auto": preview != null
        }'
        :action='action'
        :submittedCallback='submittedCallback'
        ref='modalForm'
    >
        <template #title>Select image</template>

        <template #default="{ saving, errors }">
            <div class="flex items-center gap-x-4" v-if="preview == null">
                <Select :options="folders" v-model:value="folder" @update:value="get" class="w-full" />
                
                <button class='button-black default h-12 px-6 shrink-0' @click="useDefaultImage" type='button'>
                    View default image 
                </button>
            </div>

            <ImageUploader
                title="Upload your logo"
                :minBoxes="1"
                :company="company"
                :images="folder == null ? options.images : uploads"
                formatTitle="Logo format"
                :folderId="folder"
                :cols="3"
                @selectedImage="selectedImage"
                v-show='preview == null'
            />

            <template v-if="preview != null">
                <input type="hidden" name="upload_id" :value="preview.id" />
                <input type="hidden" name="is_old_upload" :value="true" v-if="folder == null" />

                <template v-if="folder != null">
                    <p class="text-17 font-semibold">Preview</p>
                    <!-- <FilePreview :img="preview" class="mt-4" /> -->
                    <ImageEditor :image="preview" :tag='editingModel' ref="imageEditor" />
                </template>

                <template v-if="folder == null">
                    <!-- <img :src="preview.url" class="w-full h-full object-cover" /> -->

                    {{ preview }}
                </template>

                <div class="modal-buttons !grid-cols-6">
                    <ButtonSaving class="button-black default h-12" :disabled="saving">
                        Use this image
                    </ButtonSaving>

                    <ButtonSaving class="button-black-outline default h-12" :disabled="saving" type='button'>
                        Download
                    </ButtonSaving>

                    <button class="button-purple default" type="button" @click="preview = null">Back</button>
                </div>
            </template>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'
import ImageUploader from '~/components/customer/input/onboarding-image-uploader.vue'
import ImageEditor from '~/components/customer/input/image-editor.vue'

export default {
    mixins: [Modal],

    beforeMount() {
        if (this.options.folder != null) {
            this.folder = this.options.folder;
        }

        console.log(this.options)

        this.get();
    },

    data() {
        return {
            uploads: [],
            folder: 103,
            folders: [
                { html: 'Logos', value: 101 },
                { html: 'Vans', value: 102 },
                { html: 'Work', value: 103 },
                { html: 'Team', value: 104 },
                { html: 'Certificates', value: 105 },
                { html: 'Old landing page images', value: null },
            ],
            preview: null,
        }
    },

    methods: {
        get() {
            this.$axios.get(`/uploads/${this.company.id}?folder=${this.folder}`).then((res) => {
                this.uploads = res;
            });
        },

        selectedImage(img) {
            this.preview = img;
        },

        submittedCallback() {
            this.$event.$emit('modal-form-completed')
			this.$event.$emit('modal-close')
            this.$event.$emit('refresh-lp-preview')
        },

        useDefaultImage() {
            this.preview = this.options.tag.tag.default.image;
        }
    },

    computed: {
        company() {
            return this.options.company;
        },

        action() {
            if (this.options.workImage != null) {
                return "/zapo/landing-page/work-image/" + this.editingModel.id;
            }

            return "/zapo/landing-page/client-tag/" + this.editingModel.id
        }
    },

    components: {
        ImageUploader,
        ImageEditor
    }
}
</script>
